import { useContext } from 'react';
import { TradeStatus } from '@/common/TradeCard/constants';
import TradeContext from '~/context/common/TradeContext';
import { LifeCycleState } from '~/contracts/common/Trade';

export default function useGetTradeInStatus() {
  const { selectedTrade } = useContext(TradeContext);
  const { lifeCycleState, isAlmostExpired } = selectedTrade ?? {};
  const isActiveState =
    lifeCycleState === LifeCycleState.Active ||
    lifeCycleState === LifeCycleState.Scheduled ||
    lifeCycleState === LifeCycleState.AppliedToPurchase;
  const isManualState =
    lifeCycleState === LifeCycleState.Manual ||
    lifeCycleState === LifeCycleState.Rejected;

  switch (true) {
    case isActiveState && isAlmostExpired:
      return TradeStatus.ExpiringSoon;
    case isActiveState:
      return TradeStatus.Active;
    case isManualState:
      return TradeStatus.Pending;
    case lifeCycleState === LifeCycleState.Expired:
      return TradeStatus.Expired;
    default:
      return TradeStatus.None;
  }
}
